<div
  class="m-icon-field"
  [ngClass]="{
    'icon-right': iconPosition === 'right',
    'icon-left': iconPosition === 'left',
    disabled,
  }">
  @if (iconPosition === "left") {
    <span
      class="material-symbols-outlined icon-small text-blue-600"
      [class.pointer-events-none]="disabled">
      {{ icon }}
    </span>
  }
  <ng-content></ng-content>
  @if (iconPosition === "right") {
    <span
      class="material-symbols-outlined icon-small text-blue-600"
      [class.pointer-events-none]="disabled">
      {{ icon }}
    </span>
  }
</div>
